/* eslint react/no-danger: "off" */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import copy from 'copy-to-clipboard';

import './LinkShareButton.scss';

const DEFAULT_STATE = {
  text: "Link",
  icon: null,
  copied: false,
  className: ""
};
const CLICKED_STATE = {
  text: "",
  icon: "\uf119",
  copied: true,
  className: "copied"
};

export default class LinkShareButton extends Component {
  static contextTypes = {
    metrics: PropTypes.object
  };

  static propTypes = {
    copyFunction: PropTypes.func,
    timeoutFunction: PropTypes.func,
    dcmp: PropTypes.string,
    page: PropTypes.string
  };

  constructor(props){
    super(props);
    this.copyFunction = props.copyFunction || copy;
    this.state = DEFAULT_STATE;
  }

  getHref = () => {
    const {dcmp, page} = this.props;
    let href = page;

    if (dcmp) {
      href = `${page}?dcmp=sl_social_link_${dcmp}`;
    }

    return href;
  };

  handleClick = () => {
    if (this.context.metrics) {
      this.context.metrics.track("linkClick", {link: "[Article Share] Link"});
    }

    this.copyFunction(this.getHref());
    this.setState(CLICKED_STATE);

    window.setTimeout(() => this.setState(DEFAULT_STATE), 3000);
  };

  render(){
    return <div onClick={this.handleClick} className={"social-share-button-link " + this.state.className} id="social-share-link-button">
      <div className="social-share-button-link-image">
        <div id="social-share-button-link-icon" className="skycon link-icon" title="Copy link">
          {!this.state.copied && <img src={"/img/icons/link.svg"}/>}
          {this.state.copied && this.state.icon}
        </div>
      </div>
      <div id="social-share-button-link-text">{this.state.text}</div>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./modules/Common/components/LinkShareButton.js